import React, { Component } from 'react'
import { RadioButton } from './common';

class RadioButtonChonTrangThaiKHTT extends Component {

  onChange(e) {
    this.props.onChange(e);
  }

  render() {
    const data = [
      {
        ten: 'Nhập dự thảo KHTT',
        giaTri: 'NHAP_DU_THAO'
      },
      {
        ten: 'Nhập KHTT đã được phê duyệt',
        giaTri: 'NHAP_KHTT_PHE_DUYET'
      }
    ]
    return (
      <RadioButton options={data} disable={this.props.disable}
        selectedValue={this.props.selectedValue}
        keyName='giaTri'
        valueName='ten'
        onChange={this.onChange.bind(this)} />
    )
  }
}

RadioButtonChonTrangThaiKHTT.defaultProps = {
  selectedValue: 'NHAP_DU_THAO',
  className: 'input-group',
  onChange: function () {
    console.log('Need to assign onChange method');
  }
}


export default RadioButtonChonTrangThaiKHTT


// WEBPACK FOOTER //
// ./src/components/tt-forms/radiobutton-chontrangthaikhtt.jsx